import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { corporateHost } from "~/Utils";
import { useReportingConcern } from "../CorporateIntegrity.hook";
import { fields } from "../constants";

export const ReportingConcernNextPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const { data: corporateIntegrityById, isLoading: isLoadingCorporateIntegrityById, refetch: refetchCorporateIntegrityById } = useDocumentDetails(
    query?.get("id") || ""
  );  
 const { data: reportingConcernData, isLoading: isLoadingReportingConcern, refetch: refetchReportingConcern  } = useReportingConcern();

  useEffect(()=>{
    if(!query.get('id')){
      refetchReportingConcern();
    }
  },[])

  useEffect(()=>{
    if(query.get('id')){
      refetchCorporateIntegrityById();
    }
  },[query.get('id')])



  const rcDataById = {
    rcEn: JSON.parse(
      corporateIntegrityById?.payload?.field_content_english
        ? corporateIntegrityById?.payload?.field_content_english
        : "{}"
    ),
    rcMs: JSON.parse(
      corporateIntegrityById?.payload?.field_content_malay
        ? corporateIntegrityById?.payload?.field_content_malay
        : "{}"
    ),
    rcZh: JSON.parse(
      corporateIntegrityById?.payload?.field_content_mandarin
        ? corporateIntegrityById?.payload?.field_content_mandarin
        : "{}"
    ),
  };

  const ReportingConcernConfig: FormConfig = {
    initialValues: {
      field_content_english_title: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.title)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.title),
    field_content_english_description: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.description)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.description),
    field_content_english_after_submit_succesMessage: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.afterSubmit?.succesMessage)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.afterSubmit?.succesMessage),
    field_content_english_after_submit_appreciationMessage: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.afterSubmit?.appreciationMessage)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.afterSubmit?.appreciationMessage),
    field_content_english_after_submit_backToForm: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.afterSubmit?.backToForm)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.afterSubmit?.backToForm),
    field_content_english_next_page_name: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.nextPage?.name)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.nextPage?.name),
    field_content_english_next_page_link: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.nextPage?.link)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.data?.nextPage?.link),
    field_content_english_persons_titleText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.persons?.titleText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.persons?.titleText),
    field_content_english_persons_nameFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.persons?.nameFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.persons?.nameFieldText),
    field_content_english_persons_designationFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.persons?.designationFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.persons?.designationFieldText),
    field_content_english_persons_divisionOrUnitFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.persons?.divisionOrUnitFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.persons?.divisionOrUnitFieldText),
    field_content_english_persons_companyOrAirportFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.persons?.companyOrAirportFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.persons?.companyOrAirportFieldText),
    field_content_english_concerns_titleText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.concerns?.titleText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.concerns?.titleText),
    field_content_english_concerns_dateTimeFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.persons?.dateTimeFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.concerns?.dateTimeFieldText),
    field_content_english_concerns_locationOfIncidentFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.concerns?.locationOfIncidentFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.concerns?.locationOfIncidentFieldText),
    field_content_english_concerns_detailsFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.concerns?.detailsFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.concerns?.detailsFieldText),
    field_content_english_concerns_otherPartiesInvolvedFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.concerns?.otherPartiesInvolvedFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.concerns?.otherPartiesInvolvedFieldText),
    field_content_english_concerns_namesOfWitnessesInvolvedFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.concerns?.namesOfWitnessesInvolvedFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.concerns?.namesOfWitnessesInvolvedFieldText),
    field_content_english_yourParticulars_titleText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.yourParticulars?.titleText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.yourParticulars?.titleText),
    field_content_english_yourParticulars_fullnameFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.yourParticulars?.fullnameFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.yourParticulars?.fullnameFieldText),
    field_content_english_yourParticulars_staffNoFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.yourParticulars?.staffNoFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.yourParticulars?.staffNoFieldText),
    field_content_english_yourParticulars_contactNoFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.yourParticulars?.contactNoFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.yourParticulars?.contactNoFieldText),
    field_content_english_yourParticulars_emailFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.yourParticulars?.emailFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.yourParticulars?.emailFieldText),
    field_content_english_yourParticulars_companyNameFieldText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.yourParticulars?.companyNameFieldText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.yourParticulars?.companyNameFieldText),
    field_content_english_confidentialityText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.confidentialityText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.confidentialityText),
    field_content_english_captcha_titleText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.captcha?.titleText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.captcha?.titleText),
    field_content_english_captcha_helpText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.captcha?.helpText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.captcha?.helpText),
    field_content_english_captcha_newCaptchaText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.captcha?.newCaptchaText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.captcha?.newCaptchaText),
    field_content_english_submitButtonText: rcDataById?.rcEn?.data
      ? decodeHTML(rcDataById?.rcEn?.data?.labelData?.submitButtonText)
      : decodeHTML(reportingConcernData?.[0]?.field_content_english?.labelData?.submitButtonText),
      field_content_ms_title: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.title)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.title),
      field_content_ms_description: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.description)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.description),
      field_content_ms_after_submit_succesMessage: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.afterSubmit?.succesMessage)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.afterSubmit?.succesMessage),
      field_content_ms_after_submit_appreciationMessage: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.afterSubmit?.appreciationMessage)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.afterSubmit?.appreciationMessage),
      field_content_ms_after_submit_backToForm: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.afterSubmit?.backToForm)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.afterSubmit?.backToForm),
      field_content_ms_next_page_name: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.nextPage?.name)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.nextPage?.name),
      field_content_ms_next_page_link: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.nextPage?.link)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.data?.nextPage?.link),
      field_content_ms_persons_titleText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.persons?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.persons?.titleText),
      field_content_ms_persons_nameFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.persons?.nameFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.persons?.nameFieldText),
      field_content_ms_persons_designationFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.persons?.designationFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.persons?.designationFieldText),
      field_content_ms_persons_divisionOrUnitFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.persons?.divisionOrUnitFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.persons?.divisionOrUnitFieldText),
      field_content_ms_persons_companyOrAirportFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.persons?.companyOrAirportFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.persons?.companyOrAirportFieldText),
      field_content_ms_concerns_titleText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.concerns?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.concerns?.titleText),
      field_content_ms_concerns_dateTimeFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.persons?.dateTimeFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.concerns?.dateTimeFieldText),
      field_content_ms_concerns_locationOfIncidentFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.concerns?.locationOfIncidentFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.concerns?.locationOfIncidentFieldText),
      field_content_ms_concerns_detailsFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.concerns?.detailsFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.concerns?.detailsFieldText),
      field_content_ms_concerns_otherPartiesInvolvedFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.concerns?.otherPartiesInvolvedFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.concerns?.otherPartiesInvolvedFieldText),
      field_content_ms_concerns_namesOfWitnessesInvolvedFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.concerns?.namesOfWitnessesInvolvedFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.concerns?.namesOfWitnessesInvolvedFieldText),
      field_content_ms_yourParticulars_titleText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.yourParticulars?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.yourParticulars?.titleText),
      field_content_ms_yourParticulars_fullnameFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.yourParticulars?.fullnameFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.yourParticulars?.fullnameFieldText),
      field_content_ms_yourParticulars_staffNoFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.yourParticulars?.staffNoFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.yourParticulars?.staffNoFieldText),
      field_content_ms_yourParticulars_contactNoFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.yourParticulars?.contactNoFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.yourParticulars?.contactNoFieldText),
      field_content_ms_yourParticulars_emailFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.yourParticulars?.emailFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.yourParticulars?.emailFieldText),
      field_content_ms_yourParticulars_companyNameFieldText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.yourParticulars?.companyNameFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.yourParticulars?.companyNameFieldText),
      field_content_ms_confidentialityText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.confidentialityText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.confidentialityText),
      field_content_ms_captcha_titleText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.captcha?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.captcha?.titleText),
      field_content_ms_captcha_helpText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.captcha?.helpText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.captcha?.helpText),
      field_content_ms_captcha_newCaptchaText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.captcha?.newCaptchaText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.captcha?.newCaptchaText),
      field_content_ms_submitButtonText: rcDataById?.rcMs?.data
        ? decodeHTML(rcDataById?.rcMs?.data?.labelData?.submitButtonText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_malay?.labelData?.submitButtonText),
      field_content_zh_title: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.title)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.title),
      field_content_zh_description: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.description)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.description),
      field_content_zh_after_submit_succesMessage: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.afterSubmit?.succesMessage)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.afterSubmit?.succesMessage),
      field_content_zh_after_submit_appreciationMessage: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.afterSubmit?.appreciationMessage)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.afterSubmit?.appreciationMessage),
      field_content_zh_after_submit_backToForm: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.afterSubmit?.backToForm)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.afterSubmit?.backToForm),
      field_content_zh_next_page_name: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.nextPage?.name)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
      field_content_zh_next_page_link: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.nextPage?.link)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
      field_content_zh_persons_titleText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.persons?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.persons?.titleText),
      field_content_zh_persons_nameFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.persons?.nameFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.persons?.nameFieldText),
      field_content_zh_persons_designationFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.persons?.designationFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.persons?.designationFieldText),
      field_content_zh_persons_divisionOrUnitFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.persons?.divisionOrUnitFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.persons?.divisionOrUnitFieldText),
      field_content_zh_persons_companyOrAirportFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.persons?.companyOrAirportFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.persons?.companyOrAirportFieldText),
      field_content_zh_concerns_titleText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.concerns?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.concerns?.titleText),
      field_content_zh_concerns_dateTimeFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.persons?.dateTimeFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.concerns?.dateTimeFieldText),
      field_content_zh_concerns_locationOfIncidentFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.concerns?.locationOfIncidentFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.concerns?.locationOfIncidentFieldText),
      field_content_zh_concerns_detailsFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.concerns?.detailsFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.concerns?.detailsFieldText),
      field_content_zh_concerns_otherPartiesInvolvedFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.concerns?.otherPartiesInvolvedFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.concerns?.otherPartiesInvolvedFieldText),
      field_content_zh_concerns_namesOfWitnessesInvolvedFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.concerns?.namesOfWitnessesInvolvedFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.concerns?.namesOfWitnessesInvolvedFieldText),
      field_content_zh_yourParticulars_titleText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.yourParticulars?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.yourParticulars?.titleText),
      field_content_zh_yourParticulars_fullnameFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.yourParticulars?.fullnameFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.yourParticulars?.fullnameFieldText),
      field_content_zh_yourParticulars_staffNoFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.yourParticulars?.staffNoFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.yourParticulars?.staffNoFieldText),
      field_content_zh_yourParticulars_contactNoFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.yourParticulars?.contactNoFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.yourParticulars?.contactNoFieldText),
      field_content_zh_yourParticulars_emailFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.yourParticulars?.emailFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.yourParticulars?.emailFieldText),
      field_content_zh_yourParticulars_companyNameFieldText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.yourParticulars?.companyNameFieldText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.yourParticulars?.companyNameFieldText),
      field_content_zh_confidentialityText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.confidentialityText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.confidentialityText),
      field_content_zh_captcha_titleText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.captcha?.titleText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.captcha?.titleText),
      field_content_zh_captcha_helpText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.captcha?.helpText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.captcha?.helpText),
      field_content_zh_captcha_newCaptchaText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.captcha?.newCaptchaText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.captcha?.newCaptchaText),
      field_content_zh_submitButtonText: rcDataById?.rcZh?.data
        ? decodeHTML(rcDataById?.rcZh?.data?.labelData?.submitButtonText)
        : decodeHTML(reportingConcernData?.[0]?.field_content_mandarin?.labelData?.submitButtonText),
    },
    fields: fields.reportingConcernNextPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "field_content_english_image",
      "field_content_ms_image",
      "field_content_zh_image",
      "field_content_english_wicStructure_image",
      "field_content_english_procedure_image",
      "field_content_ms_wicStructure_image",
      "field_content_ms_procedure_image",
      "field_content_zh_wicStructure_image",
      "field_content_zh_procedure_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Corporate-integrity",
      subModule: `${query?.get("activeTab")}_${query.get('subActiveTab')}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Corporate-integrity_Reporting Of Concern Form",
      payload: {
        id: data?.id || reportingConcernData?.[0]?.id || corporateIntegrityById?.payload?.id,
        field_content_english: JSON.stringify(
          query?.get("activeTab") === "managementIntegrityMessage"
            ? {
                data: {
                  image: data?.field_content_english_image ?? "",
                  text: data?.field_content_english_text ?? "",
                  nextPage: {
                    name: data?.field_content_english_next_page_name ?? "",
                    link: data?.field_content_english_next_page_link ?? "",
                  },
                },
                labelData: {},
              }
            : query?.get("activeTab") === "antiBriberyCorruption"
              ? {
                  data: {
                    title: data?.field_content_english_title ?? "",
                    extroText: data?.field_content_english_extroText ?? "",
                    description: data?.field_content_english_description ?? "",
                    introText: data?.field_content_english_introText ?? "",
                    nextPage: {
                      name: data?.field_content_english_next_page_name ?? "",
                      link: data?.field_content_english_next_page_link ?? "",
                    },
                  },
                  labelData: {},
                }
              : query?.get("activeTab") === "whistleblowingProgram"
                ? {
                    data: {
                      title: data?.field_content_english_title ?? "",
                      descriptions: data?.field_content_english_descriptions ?? "",
                      wicStructure: {
                        title: data?.field_content_english_wicStructure_title ?? "",
                        image: data?.field_content_english_wicStructure_image ?? "",
                      },
                      procedure: {
                        title: data?.field_content_english_procedure_title ?? "",
                        image: data?.field_content_english_procedure_image ?? "",
                      },
                      nextPage: {
                        name: data?.field_content_english_next_page_name ?? "",
                        link: data?.field_content_english_next_page_link ?? "",
                      },
                    },
                  }
                : query?.get("activeTab") === "whistleblowingPolicy"
                  ? {
                      data: {
                        markup: data?.field_content_english_markup ?? "",
                        nextPage: {
                          name: data?.field_content_english_next_page_name ?? "",
                          link: data?.field_content_english_next_page_link ?? "",
                        },
                      },
                    }
                  : {
                      data: {
                        title: data?.field_content_english_title ?? "",
                        description: data?.field_content_english_description ?? "",
                        afterSubmit: {
                          succesMessage: data?.field_content_english_after_submit_succesMessage ?? "",
                          appreciationMessage: data?.field_content_english_after_submit_appreciationMessage ?? "",
                          backToForm: data?.field_content_english_after_submit_backToForm ?? "",
                        },
                        nextPage: {
                          name: data?.field_content_english_next_page_name ?? "",
                          link: data?.field_content_english_next_page_link ?? "",
                        },
                      },
                      labelData: {
                        persons: {
                          titleText: data?.field_content_english_persons_titleText ?? "",
                          nameFieldText: data?.field_content_english_persons_nameFieldText ?? "",
                          designationFieldText: data?.field_content_english_persons_designationFieldText ?? "",
                          divisionOrUnitFieldText: data?.field_content_english_persons_divisionOrUnitFieldText ?? "",
                          companyOrAirportFieldText: data?.field_content_english_persons_companyOrAirportFieldText ?? "",
                        },
                        concerns: {
                          titleText: data?.field_content_english_concerns_titleText ?? "",
                          dateTimeFieldText: data?.field_content_english_concerns_dateTimeFieldText ?? "",
                          locationOfIncidentFieldText: data?.field_content_english_concerns_locationOfIncidentFieldText ?? "",
                          detailsFieldText: data?.field_content_english_concerns_detailsFieldText ?? "",
                          otherPartiesInvolvedFieldText:
                            data?.field_content_english_concerns_otherPartiesInvolvedFieldText ?? "",
                          namesOfWitnessesInvolvedFieldText:
                            data?.field_content_english_concerns_namesOfWitnessesInvolvedFieldText ?? "",
                        },
                        yourParticulars: {
                          titleText: data?.field_content_english_yourParticulars_titleText ?? "",
                          fullnameFieldText: data?.field_content_english_yourParticulars_fullnameFieldText ?? "",
                          staffNoFieldText: data?.field_content_english_yourParticulars_staffNoFieldText ?? "",
                          contactNoFieldText: data?.field_content_english_yourParticulars_contactNoFieldText ?? "",
                          emailFieldText: data?.field_content_english_yourParticulars_emailFieldText ?? "",
                          companyNameFieldText: data?.field_content_english_yourParticulars_companyNameFieldText ?? "",
                        },
                        confidentialityText: data?.field_content_english_confidentialityText ?? "",
                        captcha: {
                          titleText: data?.field_content_english_captcha_titleText ?? "",
                          helpText: data?.field_content_english_captcha_helpText ?? "",
                          newCaptchaText: data?.field_content_english_captcha_newCaptchaText ?? "",
                        },
                        submitButtonText: data?.field_content_english_submitButtonText ?? "",
                      },
                    }
        ),
        field_content_malay: JSON.stringify(
          query?.get("activeTab") === "managementIntegrityMessage"
            ? {
                data: {
                  image: data?.field_content_english_image ?? "",
                  text: data?.field_content_ms_text ?? "",
                  nextPage: {
                    name: data?.field_content_ms_next_page_name ?? "",
                    link: data?.field_content_ms_next_page_link ?? "",
                  },
                },
                labelData: {},
              }
            : query?.get("activeTab") === "antiBriberyCorruption"
              ? {
                  data: {
                    title: data?.field_content_ms_title ?? "",
                    extroText: data?.field_content_ms_extroText ?? "",
                    description: data?.field_content_ms_description ?? "",
                    introText: data?.field_content_ms_introText ?? "",
                    nextPage: {
                      name: data?.field_content_ms_next_page_name ?? "",
                      link: data?.field_content_ms_next_page_link ?? "",
                    },
                  },
                  labelData: {},
                }
              : query?.get("activeTab") === "whistleblowingProgram"
                ? {
                    data: {
                      title: data?.field_content_ms_title ?? "",
                      descriptions: data?.field_content_ms_descriptions ?? "",
                      wicStructure: {
                        title: data?.field_content_ms_wicStructure_title ?? "",
                        image: data?.field_content_english_wicStructure_image ?? "",
                      },
                      procedure: {
                        title: data?.field_content_ms_procedure_title ?? "",
                        image: data?.field_content_english_procedure_image ?? "",
                      },
                      nextPage: {
                        name: data?.field_content_ms_next_page_name ?? "",
                        link: data?.field_content_ms_next_page_link ?? "",
                      },
                    },
                  }
                : query?.get("activeTab") === "whistleblowingPolicy"
                  ? {
                      data: {
                        markup: data?.field_content_ms_markup ?? "",
                        nextPage: {
                          name: data?.field_content_ms_next_page_name ?? "",
                          link: data?.field_content_ms_next_page_link ?? "",
                        },
                      },
                    }
                  : {
                      data: {
                        title: data?.field_content_ms_title ?? "",
                        description: data?.field_content_ms_description ?? "",
                        afterSubmit: {
                          succesMessage: data?.field_content_ms_after_submit_succesMessage ?? "",
                          appreciationMessage: data?.field_content_ms_after_submit_appreciationMessage ?? "",
                          backToForm: data?.field_content_ms_after_submit_backToForm ?? "",
                        },
                        nextPage: {
                          name: data?.field_content_ms_next_page_name ?? "",
                          link: data?.field_content_ms_next_page_link ?? "",
                        },
                      },
                      labelData: {
                        persons: {
                          titleText: data?.field_content_ms_persons_titleText ?? "",
                          nameFieldText: data?.field_content_ms_persons_nameFieldText ?? "",
                          designationFieldText: data?.field_content_ms_persons_designationFieldText ?? "",
                          divisionOrUnitFieldText: data?.field_content_ms_persons_divisionOrUnitFieldText ?? "",
                          companyOrAirportFieldText: data?.field_content_ms_persons_companyOrAirportFieldText ?? "",
                        },
                        concerns: {
                          titleText: data?.field_content_ms_concerns_titleText ?? "",
                          dateTimeFieldText: data?.field_content_ms_concerns_dateTimeFieldText ?? "",
                          locationOfIncidentFieldText: data?.field_content_ms_concerns_locationOfIncidentFieldText ?? "",
                          detailsFieldText: data?.field_content_ms_concerns_detailsFieldText ?? "",
                          otherPartiesInvolvedFieldText:
                            data?.field_content_ms_concerns_otherPartiesInvolvedFieldText ?? "",
                          namesOfWitnessesInvolvedFieldText:
                            data?.field_content_ms_concerns_namesOfWitnessesInvolvedFieldText ?? "",
                        },
                        yourParticulars: {
                          titleText: data?.field_content_ms_yourParticulars_titleText ?? "",
                          fullnameFieldText: data?.field_content_ms_yourParticulars_fullnameFieldText ?? "",
                          staffNoFieldText: data?.field_content_ms_yourParticulars_staffNoFieldText ?? "",
                          contactNoFieldText: data?.field_content_ms_yourParticulars_contactNoFieldText ?? "",
                          emailFieldText: data?.field_content_ms_yourParticulars_emailFieldText ?? "",
                          companyNameFieldText: data?.field_content_ms_yourParticulars_companyNameFieldText ?? "",
                        },
                        confidentialityText: data?.field_content_ms_confidentialityText ?? "",
                        captcha: {
                          titleText: data?.field_content_ms_captcha_titleText ?? "",
                          helpText: data?.field_content_ms_captcha_helpText ?? "",
                          newCaptchaText: data?.field_content_ms_captcha_newCaptchaText ?? "",
                        },
                        submitButtonText: data?.field_content_ms_submitButtonText ?? "",
                      },
                    }
        ),
        field_content_mandarin: JSON.stringify(
          query?.get("activeTab") === "managementIntegrityMessage"
            ? {
                data: {
                  image: data?.field_content_english_image ?? "",
                  text: data?.field_content_zh_text ?? "",
                  nextPage: {
                    name: data?.field_content_zh_next_page_name ?? "",
                    link: data?.field_content_zh_next_page_link ?? "",
                  },
                },
                labelData: {},
              }
            : query?.get("activeTab") === "antiBriberyCorruption"
              ? {
                  data: {
                    title: data?.field_content_zh_title ?? "",
                    extroText: data?.field_content_zh_extroText ?? "",
                    description: data?.field_content_zh_description ?? "",
                    introText: data?.field_content_zh_introText ?? "",
                    nextPage: {
                      name: data?.field_content_zh_next_page_name ?? "",
                      link: data?.field_content_zh_next_page_link ?? "",
                    },
                  },
                  labelData: {},
                }
              : query?.get("activeTab") === "whistleblowingProgram"
                ? {
                    data: {
                      title: data?.field_content_zh_title ?? "",
                      descriptions: data?.field_content_zh_descriptions ?? "",
                      wicStructure: {
                        title: data?.field_content_zh_wicStructure_title ?? "",
                        image: data?.field_content_english_wicStructure_image ?? "",
                      },
                      procedure: {
                        title: data?.field_content_zh_procedure_title ?? "",
                        image: data?.field_content_english_procedure_image ?? "",
                      },
                      nextPage: {
                        name: data?.field_content_zh_next_page_name ?? "",
                        link: data?.field_content_zh_next_page_link ?? "",
                      },
                    },
                  }
                : query?.get("activeTab") === "whistleblowingPolicy"
                  ? {
                      data: {
                        markup: data?.field_content_zh_markup ?? "",
                        nextPage: {
                          name: data?.field_content_zh_next_page_name ?? "",
                          link: data?.field_content_zh_next_page_link ?? "",
                        },
                      },
                    }
                  : {
                      data: {
                        title: data?.field_content_zh_title ?? "",
                        description: data?.field_content_zh_description ?? "",
                        afterSubmit: {
                          succesMessage: data?.field_content_zh_after_submit_succesMessage ?? "",
                          appreciationMessage: data?.field_content_zh_after_submit_appreciationMessage ?? "",
                          backToForm: data?.field_content_zh_after_submit_backToForm ?? "",
                        },
                        nextPage: {
                          name: data?.field_content_zh_next_page_name ?? "",
                          link: data?.field_content_zh_next_page_link ?? "",
                        },
                      },
                      labelData: {
                        persons: {
                          titleText: data?.field_content_zh_persons_titleText ?? "",
                          nameFieldText: data?.field_content_zh_persons_nameFieldText ?? "",
                          designationFieldText: data?.field_content_zh_persons_designationFieldText ?? "",
                          divisionOrUnitFieldText: data?.field_content_zh_persons_divisionOrUnitFieldText ?? "",
                          companyOrAirportFieldText: data?.field_content_zh_persons_companyOrAirportFieldText ?? "",
                        },
                        concerns: {
                          titleText: data?.field_content_zh_concerns_titleText ?? "",
                          dateTimeFieldText: data?.field_content_zh_concerns_dateTimeFieldText ?? "",
                          locationOfIncidentFieldText:
                            data?.field_content_zh_concerns_locationOfIncidentFieldText ?? "",
                          detailsFieldText: data?.field_content_zh_concerns_detailsFieldText ?? "",
                          otherPartiesInvolvedFieldText:
                            data?.field_content_zh_concerns_otherPartiesInvolvedFieldText ?? "",
                          namesOfWitnessesInvolvedFieldText:
                            data?.field_content_zh_concerns_namesOfWitnessesInvolvedFieldText ?? "",
                        },
                        yourParticulars: {
                          titleText: data?.field_content_zh_yourParticulars_titleText ?? "",
                          fullnameFieldText: data?.field_content_zh_yourParticulars_fullnameFieldText ?? "",
                          staffNoFieldText: data?.field_content_zh_yourParticulars_staffNoFieldText ?? "",
                          contactNoFieldText: data?.field_content_zh_yourParticulars_contactNoFieldText ?? "",
                          emailFieldText: data?.field_content_zh_yourParticulars_emailFieldText ?? "",
                          companyNameFieldText: data?.field_content_zh_yourParticulars_companyNameFieldText ?? "",
                        },
                        confidentialityText: data?.field_content_zh_confidentialityText ?? "",
                        captcha: {
                          titleText: data?.field_content_zh_captcha_titleText ?? "",
                          helpText: data?.field_content_zh_captcha_helpText ?? "",
                          newCaptchaText: data?.field_content_zh_captcha_newCaptchaText ?? "",
                        },
                        submitButtonText: data?.field_content_zh_submitButtonText ?? "",
                      },
                    }
        ),
        field_page: reportingConcernData?.[0]?.field_page || corporateIntegrityById?.payload?.field_page || "",
        published: true,
      },
      status: status,
    };

    console.log("payload", payload.payload);
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
        isLoading={
          isLoadingReportingConcern ||
          isLoadingCorporateIntegrityById
        }
          config={ReportingConcernConfig}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(
              data,
              `${corporateHost}/api/page-content/${reportingConcernData?.[0]?.id || corporateIntegrityById?.payload?.id || '85'}`,
              "UPDATE",
              "PATCH",
              buttonValue == "save" ? "DRAFT" : "PENDING",
              reviewNotes
            )
          }
          defaultReviewNotes="Kindly review this Corporate Integrity"
        />
  );
};
